import { PauseButton } from "./PauseButton";
import { ResumeButton } from "./ResumeButton";
import { ResetButton } from "./ResetButton";

const TimerButtons = ({ isPaused, pauseTimer, resumeTimer, resetTimer }) => {
  return (
    <div className="Timer-buttons">
      {isPaused ? (
        <ResumeButton onClick={resumeTimer} />
      ) : (
        <PauseButton onClick={pauseTimer} />
      )}
      <ResetButton onClick={resetTimer} />
    </div>
  );
};

export { TimerButtons };
